import moment from 'moment';
import React, { Component } from 'react';

import language from '../../../assets/languages/language';
import { fetchQuestionProgressBar, fetchTotalUsersBarGraph, fetchUsersBarGraph } from '../services';
import onGraphDataCalculation from './Config/GraphDataCalculation';
import DashboardDateFilter from './DashboardDateFilter';
import DashboardHeader from './DashboardHeader';
import PerformanceGraph from './PerformanceGraph';
import ProgressBar from './ProgressBar';
import TabList from './TabList';
import EmailResubscribe from '../../../components/EmailResubscribe';

export class ESGDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      storageSession: JSON.parse(localStorage.getItem('localstorageval')),
      startDate: '',
      endDate: '',
      formattedEndDate: '',
      formattedStartDate: '',
      tooltipOpen: false,
      ProgressBarData: [],
      progressBarLoader: false,
    };
  }
  async componentDidMount() {
    const { storageSession, formattedStartDate, formattedEndDate } = this.state;
    const data = {
      token: storageSession['token'],
      idname: storageSession['idname'],
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };
    this.setState({ PerformanceGraphLoader: 'show_block' });
    this.getBarGraph(data);
    this.getTotalUsersBarGraph(data);
    this.getQuestionProgressBar(data);
  }

  async componentDidUpdate(prevProps, prevState) {
    const { storageSession, formattedStartDate, formattedEndDate } = this.state;
    if (formattedStartDate && formattedEndDate && formattedEndDate !== prevState.formattedEndDate) {
      const data = {
        token: storageSession['token'],
        idname: storageSession['idname'],
        startDate: formattedStartDate,
        endDate: formattedEndDate,
      };
      this.getBarGraph(data);
      this.getTotalUsersBarGraph(data);
      this.getQuestionProgressBar(data);
    }
  }
  getQuestionProgressBar = async data => {
    this.setState({ progressBarLoader: true });
    const result = await fetchQuestionProgressBar(data);
    if (result.success) {
      this.setState({
        ProgressBarData: result.questionProgressBarData,
        ProgressBarTables: result.tables,
        progressBarLoader: false,
      });
    }
  };
  getBarGraph = async data => {
    const result = await fetchUsersBarGraph(data);
    if (result.success) {
      const usersBarGraphData = await onGraphDataCalculation(result.userAttemptedAndAnsweredCount);
      this.setState({ usersBarGraphData });
    }
  };

  getTotalUsersBarGraph = async data => {
    const result = await fetchTotalUsersBarGraph(data);
    if (result.success) {
      const totalUsers = await onGraphDataCalculation(result.attemptedCount);
      const barGraphLabel = await result.attemptedCount.map(chapters => {
        return chapters.chapterName.substring(0, 14);
      });
      this.setState({
        totalUsersBarGraphData: totalUsers,
        barGraphLabel,
        PerformanceGraphLoader: 'hide_block',
      });
    }
  };
  isDateHandleChange = async (date, name) => {
    const { startDate } = this.state;
    if (name === 'startDate') {
      this.setState({
        startDate: date,
        endDate: '',
        formattedEndDate: '',
        formattedStartDate: moment(date).format('YYYY-MM-DD'),
      });
    } else {
      if (startDate !== '')
        this.setState({
          endDate: date,
          formattedEndDate: moment(date).format('YYYY-MM-DD'),
          PerformanceGraphLoader: 'show_block',
        });
    }
  };

  onResetDate = () => {
    const { startDate, endDate } = this.state;
    if (startDate && endDate) {
      this.setState(
        {
          startDate: '',
          endDate: '',
          formattedStartDate: '',
          formattedEndDate: '',
        },
        () => {
          const { storageSession, formattedStartDate, formattedEndDate } = this.state;
          const data = {
            token: storageSession['token'],
            idname: storageSession['idname'],
            startDate: formattedStartDate,
            endDate: formattedEndDate,
          };
          this.getBarGraph(data);
          this.getTotalUsersBarGraph(data);
          this.getQuestionProgressBar(data);
        },
      );
    }
  };
  isTooltipToggle = () => {
    this.setState({ tooltipOpen: !this.state.tooltipOpen });
  };

  render() {
    const {
      startDate,
      endDate,
      tooltipOpen,
      totalUsersBarGraphData,
      barGraphLabel,
      PerformanceGraphLoader: performanceGraphLoader,
      usersBarGraphData,
      ProgressBarData,
      progressBarLoader,
      ProgressBarTables,
    } = this.state;
    const barGraphData = {
      labels: barGraphLabel,
      datasets: [
        {
          label: 'You',
          backgroundColor: 'rgb(31,140,235)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgb(31,140,235)',
          data: usersBarGraphData,
        },
        {
          label: 'AnalystPrep Users Average',
          backgroundColor: 'rgb(42,63,84)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgb(42,63,84)',
          data: totalUsersBarGraphData,
        },
      ],
    };
    return (
      <div className='animated fadeIn'>
        <EmailResubscribe />
        <div className='row'>
          <DashboardHeader title='ESG Dashboard' />
          <div className='col-lg-8'>
            {/* START DATE AND END DATE FILTER CODE START HERE */}
            <DashboardDateFilter
              startDate={startDate}
              endDate={endDate}
              isDateHandleChange={this.isDateHandleChange}
              resetDate={this.onResetDate}
              isTooltipToggle={this.isTooltipToggle}
              tooltipOpen={tooltipOpen}
              content={'Reset date'}
            />
            {/* PERFORMANCE GRAPH CODE ENDED HERE */}

            <PerformanceGraph
              headText={language.LC().PERFORMANCE}
              tooltipContent={language.LC().SEPARATE_YOUR_RESULT}
              tooltipPlace={'left'}
              PerformanceGraphLoader={performanceGraphLoader}
              barGraphData={barGraphData}
            />
            {/* SAVED ITEM LIST START HERE */}

            <TabList
              section='favAPIService'
              TabHeader={language.LC().MY_SAVED_ITEM_WITH_FLASH_CARD}
            />

            {/* REPORTED ITEM LIST START HERE */}
            <TabList section='reportAPIService' TabHeader={language.LC().MY_REPORTS} />
          </div>
          <div className='col-lg-4'>
            <ProgressBar
              headerName={language.LC().QUESTION_PROGRESS}
              tooltipContent={language.LC().YOU_CAN_SEE}
              tooltipPlace={'left'}
              ProgressBarData={ProgressBarData}
              progressBarLoader={progressBarLoader}
              ProgressBarTables={ProgressBarTables}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default ESGDashboard;



// WEBPACK FOOTER //
// ./src/views/ESG/Dashboard/index.jsx